import { createTheme } from '@mui/material'
import { typography } from './Typography'
import { palette, colors as mmsColors } from './ColorPalette'

const whiteBackground = {
    backgroundColor: palette.common.white,
}
const whiteBackgroundFont = {
    color: palette.common.black,
}

const grayBackground = {
    backgroundColor: '#f3f3f3',
}
const mmsTheme = createTheme({
    typography,
    palette,
    components: {
        MuiSnackbarContent: {
            styleOverrides: {
                root: {
                    backgroundColor: (palette.primary as any).dark,
                },
            }
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    height: '36px',
                },
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    padding: '0 24px 0 24px',
                    borderBottom: 'none',
                    ...whiteBackgroundFont,
                },
            }
        },
        MuiTable: {
            styleOverrides: {
                root: {
                    ...whiteBackground,
                },
            }
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    ...whiteBackgroundFont,
                },
            }
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    ...whiteBackgroundFont,
                    fontFamily: `'Titillium Web', 'sans-serif'`,
                },
            }
        },
        MuiDivider: {
            styleOverrides: {
                light: {
                    color: palette.grey!.A100,
                    backgroundColor: palette.grey!.A100,
                },
            }
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    marginRight: 0,
                },
            }
        },
        MuiTypography: {
            styleOverrides: {
                body1: {
                    ...whiteBackgroundFont,
                },
                body2: {
                    ...whiteBackgroundFont,
                },
                caption: {
                    ...whiteBackgroundFont,
                },
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 20,
                },
                containedSizeSmall: {
                    fontSize: '14px',
                    height: '40px',
                    minWidth: '120px'
                },
                outlinedSizeSmall: {
                    fontSize:'14px',
                    height: '40px',
                    minWidth: '120px'
                },
            }
        },
        MuiFilledInput: {
            styleOverrides: {
                input: {
                    ...whiteBackground,
                    borderTopLeftRadius: 3,
                    borderTopRightRadius: 3,
                    cursor: 'pointer',
                    '&:focus': {
                        ...whiteBackground,
                    },
                },
                multiline: {
                    ...whiteBackground,
                    borderTopLeftRadius: 3,
                    borderTopRightRadius: 3,
                    minHeight: 190,
                    cursor: 'pointer',
                    '&:hover': {
                        ...whiteBackground,
                    },
                    '&:focus': {
                        ...whiteBackground,
                    },
                },
                root: {
                    backgroundColor: `${palette.common!.white} !important`,
                    borderTopLeftRadius: 3,
                    borderTopRightRadius: 3,
                    cursor: 'pointer',
                    '&:hover': {
                        ...whiteBackground,
                    },
                    '&:focus': {
                        ...whiteBackground,
                    },
                },
            }
        },
        MuiSelect: {
            styleOverrides: {
                filled: {
                    ...whiteBackground,
                    border: '1px solid #989898',
                    borderRadius: '5px',
                },
                root: {
                    ...whiteBackground,
                    borderTopLeftRadius: 3,
                    borderTopRightRadius: 3,
                },
            }
        },
        MuiMenu: {
            styleOverrides: {
                paper: {
                    ...whiteBackground,
                },
            }
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    ...whiteBackground,
                    '&:hover': {
                        ...grayBackground,
                    },
                    '&$selected': {
                        backgroundColor: palette.grey!.A100,
                    },
                },
            }
        },
        MuiFormControl: {
            styleOverrides: {
                marginNormal: {
                    marginBottom: 4,
                    marginTop: 8,
                },
            }
        },
        MuiFormControlLabel: {
            styleOverrides: {
                label: {
                    ...whiteBackgroundFont,
                },
            }
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    ...whiteBackgroundFont,
                },
            }
        },
        MuiListItem: {
            styleOverrides: {
                root: {
                    ...whiteBackgroundFont,
                    textDecoration: 'none',
                },
                gutters: {
                    paddingLeft: 32,
                    paddingRight: 32,
                },
            }
        },
        MuiListItemText: {
            styleOverrides: {
                root: {
                    ...whiteBackgroundFont,
                    textDecoration: 'none',
                },
            }
        },
        MuiInput: {
            styleOverrides: {
                root: {
                    minHeight: 56,
                    ...whiteBackground,
                },
            }
        },
        MuiInputAdornment: {
            styleOverrides: {
                root: {
                    backgroundColor: 'transparent',
                },
            }
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    color: palette.grey!.A100,
                    '&$selected': {
                        color: (palette.primary as any).light,
                    },
                },
                textColorPrimary: {
                    color: palette.grey!.A700,
                },
            }
        },
        MuiTabs: {
            styleOverrides: {
                root: {
                    ...whiteBackgroundFont,
                },
            }
        },
        MuiDialogContentText: {
            styleOverrides: {
                root: {
                    ...whiteBackgroundFont,
                },
            }
        },
    },
})

export { mmsTheme, mmsColors }
